import { FieldType } from '../field-type';
import { PasteLocationEnum } from '../paste-location';
import { IPasteRule } from './ipasterule';
import { PasteAllowedRule } from './paste-allowed-rule';
import { PasteDeniedRule } from './paste-denied-rule';
import { PasteEntityFieldInDataFieldLocationRule } from './paste-entity-field-in-datafield-location-rule';
import { PasteEntityFieldInDocumentLocationRule } from './paste-entity-field-in-document-location-rule';
import { PasteScriptFieldInDataFieldLocationRule } from './paste-script-field-in-datafield-location-rule';
import { PasteScriptFieldInDocumentLocationRule } from './paste-script-field-in-document-location-rule';

/**
 * The rule table determines which rule to run based on the field being pasted and the paste location.
 *
 * Lookup is [FieldType][PasteLocation]
 */
export const pasteRuleTable: {
  [fieldToPaste in FieldType]: {
    [pasteLocation in PasteLocationEnum]: IPasteRule;
  };
} = {
  [FieldType.Entity]: {
    [PasteLocationEnum.Document]: new PasteEntityFieldInDocumentLocationRule(),
    [PasteLocationEnum.DataField]: new PasteEntityFieldInDataFieldLocationRule(),
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteAllowedRule.INSTANCE,
  },
  [FieldType.Script]: {
    [PasteLocationEnum.Document]: new PasteScriptFieldInDocumentLocationRule(),
    [PasteLocationEnum.DataField]: new PasteScriptFieldInDataFieldLocationRule(),
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteDeniedRule.INSTANCE,
  },
  [FieldType.Signature]: {
    [PasteLocationEnum.Document]: PasteAllowedRule.INSTANCE,
    [PasteLocationEnum.DataField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteAllowedRule.INSTANCE,
  },
  [FieldType.DocumentSender]: {
    [PasteLocationEnum.Document]: PasteAllowedRule.INSTANCE,
    [PasteLocationEnum.DataField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteAllowedRule.INSTANCE,
  },
  [FieldType.Image]: {
    [PasteLocationEnum.Document]: PasteAllowedRule.INSTANCE,
    [PasteLocationEnum.DataField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteAllowedRule.INSTANCE,
  },
  [FieldType.Conditional]: {
    [PasteLocationEnum.Document]: PasteAllowedRule.INSTANCE,
    [PasteLocationEnum.DataField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteDeniedRule.INSTANCE,
  },
  [FieldType.AiAssist]: {
    [PasteLocationEnum.Document]: PasteAllowedRule.INSTANCE,
    [PasteLocationEnum.DataField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.SignatureField]: PasteDeniedRule.INSTANCE,
    [PasteLocationEnum.ConditionalField]: PasteAllowedRule.INSTANCE,
  },
};
